import * as React from 'react';
import { useState } from 'react';
import { RegrasContabilizacaoService } from '../../../services/regrasContabilizacaoService';
import { useEffect } from 'react';

export const IncluirRegrasModel = () => {
  const [regras, setRegras] = useState({});
  const [temas, setTemas] = useState([]);
  const [options, setOptions] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [error, setError] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setIsLoading(true);
    const respOptions = await RegrasContabilizacaoService.getOptions();
    const respProjetos = await RegrasContabilizacaoService.getProjetos();
    if (respOptions?.status === 200 && respProjetos?.status === 200) {
      console.log('optionsData', respOptions?.data);
      setOptions(respOptions?.data);
      setProjetos(respProjetos?.data);
    } else {
      setError(true);
    }
    setIsLoading(false);
  };

  const getTemas = async (tema) => {
    const respOptions = await RegrasContabilizacaoService.getTemas(tema);
    if (respOptions?.status === 200) {
      setTemas(respOptions?.data);
    } else {
      setError(true);
    }
  };

  const updateValue = async (attr, value) => {
    const tmp = { ...regras };
    tmp[attr] = value;

    setRegras(tmp);
  };

  const recoveredByid = (arrayToFind, idFind, mustReturnInArray) => {
    const recovered = arrayToFind.find((fcl) => fcl.id === parseInt(idFind));
    const recoveredResp = mustReturnInArray ? [recovered] : recovered;
    return recoveredResp;
  };

  return {
    regras,
    setRegras,
    isLoading,
    options,
    temas,
    getTemas,
    projetos,
    error,
    setIsLoading,
    updateValue,
    recoveredByid,
  };
};
